"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AuthUserConsumer = exports.AuthUserProvider = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AuthUserContext = /*#__PURE__*/_react["default"].createContext();

var AuthUserProvider = AuthUserContext.Provider;
exports.AuthUserProvider = AuthUserProvider;
var AuthUserConsumer = AuthUserContext.Consumer;
exports.AuthUserConsumer = AuthUserConsumer;
var _default = AuthUserContext;
exports["default"] = _default;